import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Grid from '@material-ui/core/Grid';
import { API_URL } from '../common/Constants';
import axios from 'axios';
import './introduction.css';

// import Pagination from './Pagination';
// import TitleText from '../common/TitleText';

const styles = (theme) => ({
  orangeColor: {
    color: '#f5821f',
  },

  exImg: {
    width: '100%',
    height: '152px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '254px',
    },
  },

  examplesWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  examplesMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});
// const examples = [
//   { img: './images/stampbook/ex1@2x.png', text: '여주박물관' },
//   { img: './images/stampbook/ex2@2x.png', text: '국립 전주 어린이박물관' },
//   { img: './images/stampbook/ex3@2x.png', text: '노원둘레산천길' },
//   { img: './images/stampbook/ex4@2x.png', text: '남도명품길 달마고도' },
//   { img: './images/stampbook/ex5@2x.png', text: '원주시 역사박물관' },
//   { img: './images/stampbook/ex6@2x.png', text: '광교호수공원' },
//   { img: './images/stampbook/ex7@2x.png', text: '세미원 연꽃문화제' },
//   { img: './images/stampbook/ex8@2x.png', text: '수원화성성곽길' },
//   { img: './images/stampbook/ex9@2x.png', text: '회암사지박물관' },
//   { img: './images/stampbook/ex10@2x.png', text: '천연기념물센터' },
//   { img: './images/stampbook/ex11@2x.png', text: '청년 김대건의 길을 걷다' },
//   { img: './images/stampbook/ex12@2x.png', text: '송파둘레길' },
// ];
class StampBook extends Component {
  constructor(props) {
    super(props);

    this.state = { currentPage: 0, perPage: 4, imgData: '' };
    // this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {}
  // changePage(e, direction) {
  //   if (direction === 'prev') {
  //     if (this.state.currentPage > 0) {
  //       this.setState({ currentPage: this.state.currentPage - 1 });
  //     }
  //   } else {
  //     if (this.state.currentPage < parseInt(examples.length / this.state.perPage) - 1) {
  //       this.setState({ currentPage: this.state.currentPage + 1 });
  //     }
  //   }
  // }
  render() {
    // const { classes } = this.props;
    // const { currentPage, perPage } = this.state;
    // const indexFirst = perPage * currentPage;
    // const indexLast = indexFirst + perPage;
    // const showExamples = examples.slice(indexFirst, indexLast);
    return (
      <React.Fragment>
        <Topbar />
        <div className="dw_bg">
          <Grid
            id="index_grid"
            container
            justify="flex-start"
            style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
          >
            <b>제품소개 〉 스탬프 북</b>
          </Grid>
          <div className="bg_inner">
            <img
              src={this.state.imgData.m2_4}
              onContextMenu={(e) => e.preventDefault()} //스탬프 이미지 우클릭 다운로드 방지
              alt={'img'}
              style={{ width: '100%', paddingTop: '4vh', WebkitTouchCallout: 'none' }}
            />
            {/* <TitleText title="스탬프 북" />
            <p align="center" className="mainTxt">
              고객 맞춤형 디자인
              <br className={classes.examplesMob} /> 스탬프북 제작
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/stampbook/circles@2x.png" alt="" className="circles" style={{WebkitTouchCallout: 'none'}}/>
            </Grid>

            <p align="center" className="descTxt">
              완성형, 팝업형, 엽서형, 책자형 등&nbsp;
              <br className={classes.examplesMob} />
              <span className={classes.orangeColor}>대상처별 맞춤 스탬프북을 개발</span>하고
              <br />
              <span className={classes.orangeColor}>차별화된 디자인의 스탬프북</span>을 제공하여
              <br />
              <span className={classes.orangeColor}>추억의 앨범처럼 보관</span>할 수 있도록 하고 있습니다.
            </p>
            <Grid container justify="center" alignItems="center" style={{ backgroundColor: '#fde9f1' }}>
              <img src="./images/stampbook/books@2x.png" alt="" className="mainImg" style={{WebkitTouchCallout: 'none'}} />
            </Grid>
            <Grid container direction="column" justify="center" className="grayBox">
              <div className="infoTxt">
                <img src="./images/stampbook/ic_info.png" alt="infomation" style={{WebkitTouchCallout: 'none'}} />
                <p>
                  <b>다채로운 디자인 및 컨셉과 소재</b>로 제작
                </p>
              </div>

              <ul className="features">
                <li>
                  <b>다양한 디자인 경험</b>으로 제작과 구성에 대한 방향 제시
                </li>
                <li>
                  스탬프날인시 <b>번짐이나 이염이 없도록</b> 맞는 소재로 제작
                </li>
                <li>
                  <b>두원 스탬프만의 스탬프 날인면을 제공</b>함으로써 날인에 용이 (완성형 날인이미지를 구현 가능)
                </li>
                <li>
                  <b>다양한 제본, 후가공 방식</b>등을 컨셉에 맞게 다채롭게 활용
                </li>
                <li>
                  현재의 <b>트렌드 및 대상처를 분석</b>하여 <b>디자인 소스를 제공</b>
                </li>
              </ul>
            </Grid>
            <p style={{ backgroundColor: '#f5f5f5', height: '1px', width: '100%', marginBottom: '40px' }} />
            <Grid>
              <Pagination
                pageText="납품 사례"
                examples={examples}
                currentPage={this.state.currentPage}
                perPage={this.state.perPage}
                changePage={this.changePage}
              />
            </Grid>
            <Grid container className={classes.examplesMob} spacing={2} style={{ paddingTop: '40px' }}>
              {showExamples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" xs={6}>
                  <p
                    style={{
                      width: '100%',
                      margin: 0,
                      height: '25vw',
                      overflow: 'hidden',
                      border: '1px solid #efefef',
                    }}
                  >
                    <img src={example.img} alt="infomation" style={{ width: '100%', display: 'block', WebkitTouchCallout: 'none' }} />
                  </p>
                  <p style={{ fontSize: '1.1em', marginBottom: 0, wordBreak: 'keep-all', textAlign: 'center' }}>{example.text}</p>
                </Grid>
              ))}
            </Grid>
            <Grid container className={classes.examplesWeb} style={{ paddingTop: '20px' }} spacing={3}>
              {examples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" sm={3}>
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className={classes.exImg}
                    style={{ margin: 0, border: '1px solid #efefef' }}
                  >
                    <img src={example.img} alt="infomation" style={{ width: '95%', display: 'block', WebkitTouchCallout: 'none' }} />
                  </Grid>
                  <p className="exTxt">{example.text}</p>
                </Grid>
              ))}
            </Grid> */}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(StampBook));
